import {Store} from 'src/types/store';
import {CourseForm} from 'portfolio/components/bulk-entry/course-form-wrapper';

export const RECEIVE_OCR_COURSES = ' RECEIVE_OCR_COURSES';
export const SET_IS_NEXT = ' SET_IS_NEXT';
export const SET_IS_BACK = ' SET_BACK';
export const SET_COURSE_IDS_TO_DELETE = 'SET_COURSE_IDS_TO_DELETE';
export const SET_SHOW_SURVEY = 'SET_SHOW_SURVEY';

export const LOCAL_STORAGE_KEY = 'reportCardFormattedOcrCourses';

export const receiveOcrCourses = (courses: CourseForm[]) => {
  window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(courses));

  return {
    type: RECEIVE_OCR_COURSES,
    courses,
  };
};

export const getOcrCourses = (state: Store) => {
  const cachedCourses = window.localStorage.getItem(LOCAL_STORAGE_KEY);

  if (state.reportCard.courses.length) {
    return state.reportCard.courses;
  } else if (cachedCourses) {
    return JSON.parse(cachedCourses);
  } else {
    return [];
  }
};

export const setIsBack = (isBack: boolean) => ({
  type: SET_IS_BACK,
  isBack,
});

export const getIsBack = (state: Store) => state.reportCard.isBack;

export const setIsNext = (isNext: boolean) => ({
  type: SET_IS_NEXT,
  isNext,
});

export const getIsNext = (state: Store) => state.reportCard.isNext;

export const handleBack = () => (dispatch) => {
  dispatch(setIsBack(true));
  dispatch(setIsNext(false));
};

export const handleNext = () => (dispatch) => {
  dispatch(setIsBack(false));
  dispatch(setIsNext(true));
};

export const clearOcrCourses = () => (dispatch) => {
  window.localStorage.removeItem(LOCAL_STORAGE_KEY);
  dispatch(receiveOcrCourses([]));
};

export const setCourseIdsToDelete = (courseIdsToDelete: string[]) => ({
  type: SET_COURSE_IDS_TO_DELETE,
  courseIdsToDelete,
});

export const getCourseIdsToDelete = (state: Store) => state.reportCard.courseIdsToDelete;

export const setShowSurvey = (showSurvey: boolean) => ({
  type: SET_SHOW_SURVEY,
  showSurvey,
});

export const getShowSurvey = (state: Store) => state.reportCard.showSurvey;
